<template>
	<div>
		<div class="modal fade" ref="modal" data-backdrop="static">
			<div
				class="modal-dialog"
				:class="{ 'modal-lg': !blockExams, 'modal-sm': blockExams }"
			>
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel">
							Solicitação
						</h4>
					</div>
					<div class="modal-body">
						<div class="row">
							<div
								:class="{
									'col-md-4': !blockExams,
									'col-md-12': blockExams,
								}"
							>
								<div class="row">
									<div class="col-md-12 col-sm-4">
										<b>Colaborador</b>
										<select-patient
											ref="cmpSP"
											v-model="form.matricula"
											@openMdCreatePatient="
												$refs.mdCreatePatient.open()
											"
										/>
									</div>
									<div class="col-md-12 col-sm-5">
										Mês da Convocação
										<input
											v-model="form.convocacao"
											type="month"
											class="form-control"
										/>
									</div>
									<div class="col-md-12 col-sm-3">
										Tipo de Operação
										<select
											v-model="form.operacao"
											disabled
											class="form-control"
										>
											<option value="I">Inclusão</option>
											<option value="A">Alteração</option>
										</select>
									</div>
									<div class="col-md-12 col-sm-4">
										Tipo de Resultdos
										<select
											v-model="form.resultados"
											class="form-control"
										>
											<option value="A">
												Admissional
											</option>
											<option value="D">
												Demissional
											</option>
											<option value="P">Periódico</option>
											<option value="E">Especial</option>
											<option value="M">
												Mudança de Função
											</option>
											<option value="R">
												Retorno ao Trabalho
											</option>
											<option value="S">Supletiva</option>
										</select>
									</div>

									<div class="col-md-12 col-sm-4">
										Empresa
										<select
											v-model="form.empresa"
											class="form-control"
										>
											<option
												v-for="(empresa, index) in assets.empresas"
												:key="index"
												:value="empresa.cod"
											>
												{{ empresa.title }} ({{
													empresa.cod
												}})
											</option>
										</select>
									</div>
									<div class="col-md-12 col-sm-4">
										Unidade
										<select
											v-model="form.unidade"
											class="form-control"
										>
											<option
												v-for="(unidade, index) in filterUnidades"
												:key="index"
												:value="unidade.cod"
											>
												{{ unidade.title }} ({{
													unidade.cod
												}})
											</option>
										</select>
									</div>
								</div>
							</div>
							<div v-if="!blockExams" class="col-md-8">
								<exams-cmp v-model="form.exams" />
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default pull-left"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
						<button
							:disabled="!is_valid()"
							@click="save"
							type="button"
							class="btn btn-primary"
						>
							<i class="fa fa-save"></i> Salvar
						</button>
					</div>
				</div>
			</div>
		</div>
		<md-create-patient ref="mdCreatePatient" @update="selectPatient" />
	</div>
</template>
<script>
	import WBS from 'js/http';
	import aBtn from 'btn';
	import examsCmp from './components/exams.vue';
	import { clone } from 'lodash';
	import toastr from 'toastr';
	import selectPatient from './components/select-patient.vue';
	import mdCreatePatient from '../../entradas/components/mdCreatePatient.vue';

	const reset = {
		convocacao: ((e) => {
			let date = new Date();
			if (date.getMonth() <= 9)
				return `${date.getFullYear()}-0${date.getMonth() + 1}`;
			else return `${date.getFullYear()}-${date.getMonth() + 1}`;
		})(),
		operacao: 'I',
		resultados: 'P',
		empresa: '001 ',
		unidade: '001RPBC',
		matricula: '',
		exams: [],
	};

	export default {
		name: 'modalSolicitation',
		components: { aBtn, examsCmp, selectPatient, mdCreatePatient },
		inject: ['assets'],
		data() {
			return {
				form: clone(reset),
				blockExams: false,
			};
		},
		methods: {
			selectPatient(val) {
				this.$refs.cmpSP.selected(val);
			},
			save() {
				WBS.send(
					'private-save-sd2000CreateSolicitation',
					this.form,
					(resp) => {
						// console.log(resp)
						if (resp.status == 'success') {
							toastr.success(
								'Solicitação cadastrado com sucesso'
							);
							$(this.$refs.modal).modal('hide');
							this.$emit('update');
						} else {
							toastr.error('Erro ao cadastrar solicitação');
							console.log(resp);
						}
					}
				);
			},
			is_valid() {
				if (!this.blockExams)
					return this.form.exams.length > 0 && this.matricula != '';
				else return this.matricula != '';
			},
			open(data = null) {
				if (data != null) {
					let dataOpen = JSON.parse(JSON.stringify(data));
					dataOpen.matricula = dataOpen.matricula.mat;
					this.form = dataOpen;
					this.blockExams = true;
				} else {
					this.form = clone(reset);
					this.blockExams = false;
				}
				$(this.$refs.modal).modal('show');
			},
		},
		watch: {
			filterUnidades: function (val) {
				if (parseInt(this.form.empresa) == 1)
					this.form.unidade = '001RPBC';
				else this.form.unidade = val[0].cod;
			},
		},
		computed: {
			filterUnidades() {
				return this.assets.unidades.filter(
					(item) => item.eid == parseInt(this.form.empresa)
				);
			},
		},
	};
</script>
<style scoped>
	.col-md-12 {
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/mdCreateSolicitation/index.vue